import turmimaxBefore from "@/assets/turmimax-ultra-before.webp";
import turmimaxAfter from "@/assets/turmimax-ultra-after.webp";
import greensBefore from "@/assets/daily-defence-greens-before.webp";
import greensAfter from "@/assets/daily-defence-greens-after.webp";
import alignWellness from "@/assets/align-wellness-clinic.webp";

export type CaptionLine = { text: string; flag?: boolean; tick?: boolean };

export type TabData = {
  label: string;
  brand: string;
  imageBefore: string;
  imageAfter: string;
  before: CaptionLine[];
  after: CaptionLine[];
};

export const TABS: TabData[] = [
  {
    label: "Listed Medicine (AUST-L)",
    brand: "VitaWell Australia",
    imageBefore: turmimaxBefore,
    imageAfter: turmimaxAfter,
    before: [
      { text: "🔥 TurmiMax Ultra — the CURE for chronic inflammation!", flag: true },
      { text: "Our clinically proven formula TREATS arthritis, joint pain and gut inflammation fast. 95% of users report complete pain relief within 7 days.", flag: true },
      { text: "\"I stopped taking my prescription meds after 2 weeks on TurmiMax — my doctor was shocked!\" — Sarah M., verified buyer", flag: true },
      { text: "🛒 Shop now — link in bio" },
      { text: "#AntiInflammatory #CureArthritis #NaturalMedicine #PainFree", flag: true },
    ],
    after: [
      { text: "TurmiMax Ultra — traditional turmeric support for joint health and mobility.", tick: true },
      { text: "Formulated with turmeric and BioPerine® to support healthy inflammatory response and joint comfort. Each capsule contains 600mg standardised curcuminoids.", tick: true },
      { text: "Always read the label and follow the directions for use. If symptoms persist, talk to your health professional. Supplements should not replace a balanced diet. AUST L 456789.", tick: true },
      { text: "🛒 Shop now — link in bio", tick: true },
      { text: "#JointHealth #TurmericSupport #AustralianMade", tick: true },
    ],
  },
  {
    label: "Food-Medicine Interface",
    brand: "GreenRoots Co.",
    imageBefore: greensBefore,
    imageAfter: greensAfter,
    before: [
      { text: "💚 Daily Defence Greens — BOOST your immune system and FIGHT off illness this winter!", flag: true },
      { text: "Packed with medicinal mushrooms clinically shown to prevent colds and flu. Our lion's mane complex also improves memory and treats brain fog.", flag: true },
      { text: "Recommended by 200+ naturopaths across Australia.", flag: true },
      { text: "🛒 Link in bio — use code IMMUNE30 for 30% off" },
      { text: "#ImmuneBooster #FightFlu #MedicinalMushrooms #BrainHealth", flag: true },
    ],
    after: [
      { text: "Daily Defence Greens — your daily serve of whole-food nutrition.", tick: true },
      { text: "A blend of organic greens, reishi, and lion's mane mushroom powder. Each serve provides vitamin C (from kakadu plum) which contributes to normal immune system function.", tick: true },
      { text: "This product is not a sole source of nutrition and should be consumed in conjunction with a nutritious diet.", tick: true },
      { text: "🛒 Link in bio — use code GREEN30 for 30% off", tick: true },
      { text: "#DailyGreens #WholeFood #PlantBased", tick: true },
    ],
  },
  {
    label: "Practitioner Clinic",
    brand: "Align Wellness Clinic",
    imageBefore: alignWellness,
    imageAfter: alignWellness,
    before: [
      { text: "🙌 We GUARANTEE results — or your money back!", flag: true },
      { text: "Dr. Alex Chen has successfully cured hundreds of patients suffering from chronic back pain, sciatica and migraines. Our unique spinal correction technique is the most advanced treatment available in Australia.", flag: true },
      { text: "Before & after X-rays available on request — see the proof for yourself!", flag: true },
      { text: "Book your FREE assessment today — link in bio" },
      { text: "#ChiropracticCure #BackPainCure #BestChiropractor #GuaranteedResults", flag: true },
    ],
    after: [
      { text: "Supporting your spine health with evidence-informed chiropractic care.", tick: true },
      { text: "Dr. Alex Chen provides chiropractic assessment and manual therapy for musculoskeletal conditions. Treatment plans are tailored to your individual presentation and goals.", tick: true },
      { text: "Initial consultations include a thorough assessment to determine whether chiropractic care is appropriate for you.", tick: true },
      { text: "Book your initial consultation today — link in bio", tick: true },
      { text: "#Chiropractic #SpineHealth #AlignWellness", tick: true },
    ],
  },
];
